import React from 'react'

export default function New() {
  return (
    <div className="screen-container">New</div>
  )
}
